import QuestionManagement from './QuestionManagement';

export default QuestionManagement;
